// tslint:disable
export var TCSPromotionSearchScope;
(function (TCSPromotionSearchScope) {
    // Search within brand
    TCSPromotionSearchScope[TCSPromotionSearchScope["Brand"] = 0] = "Brand";
    // Search within the entire program that the promotion is associated with
    TCSPromotionSearchScope[TCSPromotionSearchScope["ProgramId"] = 1] = "ProgramId";
    // Search within promotion group
    TCSPromotionSearchScope[TCSPromotionSearchScope["PromotionGroup"] = 2] = "PromotionGroup";
})(TCSPromotionSearchScope || (TCSPromotionSearchScope = {}));
TCSPromotionSearchScope['BRAND'] = 0;
TCSPromotionSearchScope['PROGRAMID'] = 1;
TCSPromotionSearchScope['PROMOTIONGROUP'] = 2;
//# sourceMappingURL=TCSPromotionSearchScope.js.map